export default __webpack_public_path__ + "static/media/icon_format_img.4e1b6e4e.svg";